import * as _ from "lodash";

export function normalizeCommitish(value?: string): string {
  if (!value) {
    return '';
  }

  try {
    return decodeURIComponent(value);
  } catch (error) {
    return value;
  }
}

export function decodeParams(params?: object): object {
    return _.forEach(params, (value, key) => {
        if (typeof value === 'string') {
            params[key] = decodeURIComponent(value);
        } else {
            params[key] = value;
        }
    });
}
